import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { StatisticheRequest } from "../model/requests/StatisticheRequest";
import { StatisticheResponse } from "../model/responses/StatisticheResponse";
import { environment } from "../../environments/environment";
import { firstValueFrom } from "rxjs";

const BASE_URL = environment.baseUrl;

@Injectable({
  providedIn: 'root'
})
export class StatisticheApiService {

  constructor(private httpClient: HttpClient) {
  }

  async getStats(request: StatisticheRequest): Promise<StatisticheResponse | undefined> {
    try {
      const response = await firstValueFrom(
        this.httpClient.request<StatisticheResponse>('post', `${BASE_URL}/api/statistics`, {
          body: request,
          observe: 'body',
          responseType: 'json' // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
        })
      );
      return response;
    } catch (error) {
      return undefined;
    }
  }

  async exportReport(request: StatisticheRequest): Promise<Blob> {
    return await firstValueFrom(this.httpClient.post(`${BASE_URL}/api/statistics/export`, request, {
      headers: {
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      },
      responseType: 'blob'
    })
    );
  }
  async getQuickLink() {
    const obj = await firstValueFrom(this.httpClient.request('get', `${BASE_URL}/api/quicksight`, {

        observe: 'body',
        responseType: 'json' // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
      }));
      console.log(obj)
    return obj;

  }

  async getQuickSightLinkForAnia() {
    const obj = await firstValueFrom(this.httpClient.request('get', `${BASE_URL}/api/quicksight-sic-ania`, {

        observe: 'body',
        responseType: 'json' // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
      }));
      console.log(obj)
    return obj;

  }

  async getQuickSightLinkForSmsSender() {
    const obj = await firstValueFrom(this.httpClient.request('get', `${BASE_URL}/api/quicksight-sms-sender`, {

        observe: 'body',
        responseType: 'json' // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
      }));
      console.log(obj)
    return obj;

  }
  async getQuickSightLinkForSmartSummary() {
    const obj = await firstValueFrom(this.httpClient.request('get', `${BASE_URL}/api/quicksight-smart-summary`, {

        observe: 'body',
        responseType: 'json' // Assicurati che 'observe' sia impostato su 'body' per ricevere il payload della risposta
      }));
      console.log(obj)
    return obj;

  }
}
